<bb-illustration-ui
  name="ic_graph_bar_chart"
  size="md"
></bb-illustration-ui>
